import { keyframes } from '@emotion/css';
import styled from '@emotion/styled';

import { ManageButton } from './Onboarding/ManageButton';

const buttonClickAnim = keyframes`
from {
  box-shadow: 0px 0px 0px 0px rgba(25, 157, 185, 0.2);
}
to {
  box-shadow: 0px 0px 0px 5px rgba(25, 157, 185, 0.2);
}
`;

export const ClickAnimationButton = styled(ManageButton)<{
  animationDisabled?: boolean;
}>`
  display: flex;
  align-items: center;

  ${({ animationDisabled }) =>
    animationDisabled ? '' : ` animation: ${buttonClickAnim} 0.8s ease-in-out infinite;`}
`;
